export default __webpack_public_path__ + "static/media/NIAS0170.34I-41302_-24647_0.98812544.jpg";